/* eslint-disable react/prop-types */

import { IMAGE_URL } from "../../constants";
import NumberCounter from "../home/NumberCounter";

const LibraryStats = ({ stats }) => {
  return (
    <div className="mt-5">
      <div className="grid grid-cols-1 gap-6 mt-8 sm:grid-cols-2 lg:grid-cols-5 md:gap-8">
        {stats?.map((item) => (
          <div
            key={item.id}
            className="flex items-center gap-4 p-4 transition-colors duration-300 bg-white/50 rounded-xl hover:bg-white"
          >
            {/* Icon / Image */}
            <div className="p-4 bg-white shadow-md rounded-2xl sm:p-6">
              {item.image ? (
                <img
                  src={`${IMAGE_URL}/${item.image}`}
                  alt={item.description}
                  className="w-8 h-8 object-contain"
                />
              ) : (
                <div className="w-8 h-8 bg-gray-200 rounded" />
              )}
            </div>

            {/* Counter + Label */}
            <div>
              {/* Extract number part from title if it's not numeric */}
              <NumberCounter
                endValue={parseInt(item.title)}
                duration={2000}
                suffix={item.title.replace(/[0-9]/g, "")} // keeps "+" or other chars
              />
              <p className="mt-1 text-sm text-gray-600">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LibraryStats;
